import React from "react";

const RupeesPocket = ({
    width = 34,
    height = 46,
    color = "#1B75F0",
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 34 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path d="M13.0862 14.4808H10.1881C9.03573 14.4808 8.10156 13.5467 8.10156 12.3943C8.10156 11.2419 9.03573 10.3077 10.1881 10.3077H23.8087C24.9611 10.3077 25.8953 11.2419 25.8953 12.3943C25.8953 13.5467 24.9611 14.4808 23.8087 14.4808H20.9107" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M23.8103 14.4809L31.0936 25.8983C36.1993 33.9021 30.4505 44.3882 20.9569 44.3882H13.0432C3.54949 44.3882 -2.19932 33.9021 2.9064 25.8983L10.1897 14.4809" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.91602 2.37152C8.91791 1.36963 10.5423 1.36963 11.5441 2.37152L11.5505 2.37787C12.5499 3.37724 14.1693 3.38011 15.1723 2.38422L15.1978 2.35883C16.2007 1.36294 17.8202 1.3658 18.8196 2.36518L18.8259 2.37152C19.8278 3.37342 21.4522 3.37342 22.4541 2.37152C23.4559 1.36963 25.0803 1.36963 26.0822 2.37152L23.8122 10.3077H10.1917L7.91602 2.37152Z" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.3898 24.7295C19.3898 24.7295 17.8193 23.5397 15.9326 24.1064C14.0068 24.685 13.529 27.3208 14.8374 28.3471C15.5887 28.9364 16.7191 29.4208 18.2427 29.9594C21.6524 31.1646 20.3919 35.9734 16.9234 35.9965C15.5699 36.0054 14.9371 35.9195 13.748 35.1417" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17 22.3054V37.7517" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default RupeesPocket;